import SEAT_CHOICE_TYPES from '../../scripts/constants/seat-choice-types';

import SeatChoiceUpsellUIModel from './seat-choice-upsell';
import SeatChoiceFareUpgradeUIModel from './seat-choice-fare-upgrade';
import SeatmapRowUIModel from './seatmap-row';

class SeatmapSectionUIModel {
  /**
   * constructor
   * @param {Object} options
   */
  constructor({
    bestSeatUpgrade = null,
    code = '',
    rows = [],
    isPremierLight = false,
  }) {
    this.code = code;
    this.rows = rows._collection.map(row => {
      row.sectionClass = code;
      row.isPremierLight = isPremierLight;
      return new SeatmapRowUIModel(row);
    });

    if (bestSeatUpgrade) {
      const bestSeatUpgradeClass = bestSeatUpgrade._meta.class;
      if (bestSeatUpgradeClass === SEAT_CHOICE_TYPES.SEAT_CHOICE_UPSELL) {
        this.bestSeatUpgrade = new SeatChoiceUpsellUIModel(bestSeatUpgrade);
      } else if (bestSeatUpgradeClass === SEAT_CHOICE_TYPES.SEAT_CHOICE_FARE_UPGRADE) {
        this.bestSeatUpgrade = new SeatChoiceFareUpgradeUIModel(bestSeatUpgrade);
      }
    }
  }
}

export default SeatmapSectionUIModel;
